const initialState = {
  detail_transaction: '',
};

const hotelDetailTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DETAIL_TRANSACTION':
      return {
        detail_transaction: action.payload,
      };
    default:
      return state;
  }
};

export default hotelDetailTransactionReducer;
